interface Props {
  dateTime: string
  language: string
  alpha2: string
}

export const convertToDate = ({ dateTime, language, alpha2 }: Props) => {
  const date = new Date(dateTime)

  const formattedDate = date.toLocaleDateString(`${language}-${alpha2}`, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  })

  const weekday = date.toLocaleDateString(`${language}-${alpha2}`, {
    weekday: 'short',
    timeZone: 'UTC',
  })

  return `${formattedDate} (${weekday})`
}
